<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.FirearmAssignment@Pending">Pending Firearm Assignments</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Asset Id" [matTooltipDisabled]="disabledTooltip(this.assetId)">
          <mat-label i18n="@@type.FirearmAssignment.assetId">Asset Id</mat-label>
          <input matInput formControlName="assetId" id="assetIdFilterInput"
              [(ngModel)]="assetIdFilter" #assetIdFilterInput type="number" placeholder="Asset Id">
        </mat-form-field>

        <mat-form-field matTooltip="Search asset identity reference or description"
            [matTooltipDisabled]="disabledTooltip(this.identityReferenceOrDescription)">
          <mat-label>Id Reference/Description</mat-label>
          <input matInput formControlName="identityReferenceOrDescription" id="identityReferenceOrDescriptionFilterInput"
              [(ngModel)]="identityReferenceOrDescriptionFilter" #identityReferenceOrDescriptionFilterInput
              placeholder="Id Reference/Description">
        </mat-form-field>

        <mat-form-field matTooltip="Select a Firearm Assignment Type from the list" [matTooltipDisabled]="disabledTooltip(this.firearmAssignmentType)">
          <mat-label i18n="@@type.FirearmAssignment.firearmAssignmentType">Firearm Assignment Type</mat-label>
          <mat-select formControlName="firearmAssignmentType" id="firearmAssignmentTypeFilterInput"              
              (ngModelChange)="firearmAssignmentTypeChanging($event)" [(ngModel)]="firearmAssignmentTypeFilter"              
              (ngModelChange)="firearmAssignmentTypeChanged($event)" #firearmAssignmentTypeFilterInput              
              placeholder="Firearm Assignment Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearmAssignmentType of firearmAssignmentTypeSelectionList" [value]="firearmAssignmentType.code">
              {{firearmAssignmentType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Storage Type from the list" [matTooltipDisabled]="disabledTooltip(this.storageType)">
          <mat-label i18n="@@type.FirearmAssignment.storageType">Storage Type</mat-label>
          <mat-select formControlName="storageType" id="storageTypeFilterInput"              
              (ngModelChange)="storageTypeChanging($event)" [(ngModel)]="storageTypeFilter"              
              (ngModelChange)="storageTypeChanged($event)" #storageTypeFilterInput              
              placeholder="Storage Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let storageType of storageTypeSelectionList" [value]="storageType.code">
              {{storageType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Next Action from the list" [matTooltipDisabled]="disabledTooltip(this.nextAction)">
          <mat-label i18n="@@type.FirearmAssignment.nextAction">Next Action</mat-label>
          <mat-select formControlName="nextAction" id="nextActionFilterInput"              
              (ngModelChange)="nextActionChanging($event)" [(ngModel)]="nextActionFilter"              
              (ngModelChange)="nextActionChanged($event)" #nextActionFilterInput              
              placeholder="Next Action">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let nextAction of nextActionSelectionList" [value]="nextAction.code">
              {{nextAction.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="lastStateChangeDate"
          matSortDisableClear cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="firearmAssignmentId">
            <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.firearmAssignmentId">
              Firearm Assignment Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmAssignmentId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actionPending">
            <mat-header-cell [crud-column-header]="columns.column('actionPending')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.actionPending">
              Action Pending
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.actionPending">check_box</mat-icon><mat-icon
                *ngIf="!element.actionPending">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="assetId">
            <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.assetId">
              Asset Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearm?.assetId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="buApprovalRejectionReason">
            <mat-header-cell [crud-column-header]="columns.column('buApprovalRejectionReason')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.buApprovalRejectionReason">
              Bu Approval Rejection Reason
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovalRejectionReason}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="buApproved">
            <mat-header-cell [crud-column-header]="columns.column('buApproved')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.buApproved">
              Bu Approved
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.buApproved">check_box</mat-icon><mat-icon
                *ngIf="!element.buApproved">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="buApprovedRejectedBy">
            <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedBy')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.buApprovedRejectedBy">
              Bu Approved Rejected By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovedRejectedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="buApprovedRejectedDate">
            <mat-header-cell [crud-column-header]="columns.column('buApprovedRejectedDate')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.buApprovedRejectedDate">
              Bu Approved Rejected Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.buApprovedRejectedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.businessUnit">
              Business Unit
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{businessUnitDisplay(element.businessUnit)}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.comments">
              Comments
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.createdBy">
              Created By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.createdDate">
              Created Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="currentAssignment">
            <mat-header-cell [crud-column-header]="columns.column('currentAssignment')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.currentAssignment">
              Current Assignment
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.currentAssignment">check_box</mat-icon><mat-icon
                *ngIf="!element.currentAssignment">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="endDate">
            <mat-header-cell [crud-column-header]="columns.column('endDate')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.endDate">
              End Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.endDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="firearm.assetId">
            <mat-header-cell [crud-column-header]="columns.column('firearm.assetId')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.FirearmAssignment.firearm">
              Firearm
            </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{firearmDisplay(element.firearm)}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="firearmAssignmentType">
            <mat-header-cell [crud-column-header]="columns.column('firearmAssignmentType')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.firearmAssignmentType">
              Firearm Assignment Type
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmAssignmentType | refDecode:'FIREARM_ASSIGNMENT_TYPE' | async}}
              {{element.personalFirearmAssignment ? ' (Personal)' : ''}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="leadApprovalRejectionReason">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovalRejectionReason')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.leadApprovalRejectionReason">
              Lead Approval Rejection Reason
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovalRejectionReason}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="leadApproved">
            <mat-header-cell [crud-column-header]="columns.column('leadApproved')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.leadApproved">
              Lead Approved
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.leadApproved">check_box</mat-icon><mat-icon
                *ngIf="!element.leadApproved">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="leadApprovedRejectedBy">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedBy')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.leadApprovedRejectedBy">
              Lead Approved Rejected By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovedRejectedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="leadApprovedRejectedDate">
            <mat-header-cell [crud-column-header]="columns.column('leadApprovedRejectedDate')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.leadApprovedRejectedDate">
              Lead Approved Rejected Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.leadApprovedRejectedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastStateChangeDate">
            <mat-header-cell [crud-column-header]="columns.column('lastStateChangeDate')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.lastStateChangeDatePendingSince">
              Pending Since
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lastStateChangeDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lifecycleState">
            <mat-header-cell [crud-column-header]="columns.column('lifecycleState')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.lifecycleState">
              Lifecycle State
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <span *ngIf="element.actionPending">{{element.lifecycleState |
                refDecode:'FIREARM_ASSIGNMENT_LIFECYCLE_STATE' | async}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nextAction">
            <mat-header-cell [crud-column-header]="columns.column('nextAction')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.nextAction">
              Pending Action
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <span *ngIf="element.nextAction">{{element.nextAction | refDecode:'FIREARM_ASSIGNMENT_NEXT_ACTION' |
                async}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="notifyPolice">
            <mat-header-cell [crud-column-header]="columns.column('notifyPolice')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.notifyPolice">
              Notify Police
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.notifyPolice">check_box</mat-icon><mat-icon
                *ngIf="!element.notifyPolice">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="personEmail">
            <mat-header-cell [crud-column-header]="columns.column('personEmail')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.FirearmAssignment.personEmail">
              Person
            </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.personEmail}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rangerId">
            <mat-header-cell [crud-column-header]="columns.column('rangerId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.rangerId">
              Ranger Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.rangerId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sortDate">
            <mat-header-cell [crud-column-header]="columns.column('sortDate')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.sortDate">
              Sort Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.sortDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="startDate">
            <mat-header-cell [crud-column-header]="columns.column('startDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.startDate">
              Start Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.startDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="startedBy">
            <mat-header-cell [crud-column-header]="columns.column('startedBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.startedBy">
              Started By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.startedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="storageType">
            <mat-header-cell [crud-column-header]="columns.column('storageType')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.storageType">
              Storage Type
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.storageType | refDecode:'FIREARM_ASSIGNMENT_STORAGE_TYPE' | async}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.updatedBy">
              Updated By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.updatedDate">
              Updated Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="username">
            <mat-header-cell [crud-column-header]="columns.column('username')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.FirearmAssignment.username">
              Username
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.username}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions search-column-smallx3 mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions search-column-smallx3 mat-elevation-z9">
              <button class="action-button" *ngIf="allowsApproval(element)" mat-raised-button color="primary"
                (click)="launchApproval(element)" i18n="@@actions.approve_or_reject"
                id="actions.approve_or_reject">Approve/Reject</button>
              <button class="action-button" *ngIf="allowsCancellation(element)" mat-raised-button color="accent2"
                (click)="launchCancellation(element)" i18n="@@actions.cancel" id="actions.cancel">Cancel
                Assignment</button>
              <button class="action-button" *ngIf="availableActivation(element)" [disabled]="!allowsActivation(element)"
                mat-raised-button color="primary" (click)="launchActivation(element)" i18n="@@actions.activate"
                id="actions.activate" matTooltip="Initiate Handover">Handover</button>
              <button class="action-button" *ngIf="availablePopulate(element)" mat-raised-button color="primary"
                [routerLink]="firearmRoute(element)" i18n="@@actions.updateFirearm"
                id="actions.updateFirearm">Populate</button>
              <button class="action-button" *ngIf="element.firearm?.assetId" mat-raised-button color="primary"
                [routerLink]="viewFirearmRoute(element)" i18n="@@actions.viewFirearm"
                id="actions.viewFirearm">Firearm</button>
              <button class="action-button" *ngIf="availableUploadDisposalDocuments(element)" mat-raised-button color="primary"
                (click)="openFirearmDisposalDocumentDialog(element)" i18n="@@actions.uploadDisposalDocument"
                id="actions.uploadDisposalDocument">Upload Evidence</button>
              <button class="action-button" *ngIf="availableViewDisposalDocuments(element)" mat-raised-button color="primary"
                (click)="openFirearmDisposalDocumentDialog(element)"
                id="actions.viewDisposalDocument">View Evidence</button>
              <button class="action-button" *ngIf="allowsStartAssignment(element)" mat-raised-button color="primary"
                (click)="launchStartAssignment(element)" i18n="@@actions.confirmActivation"
                id="actions.activate" matTooltip="Confirm Handover">Confirm
                Handover</button>
              <button class="action-button" *ngIf="allowsCompleteDisposal(element)" mat-raised-button color="primary"
                (click)="launchCompleteDisposal(element)" i18n="@@actions.completeDisposal"
                id="actions.completeDisposal">Complete Disposal</button>
              <button class="action-button" *ngIf="allowsReissueStartToken(element)" mat-raised-button color="accent2"
                (click)="launchReissueStartToken(element)" i18n="@@actions.launchReissueStartToken"
                id="actions.launchReissueStartToken" matTooltip="Resend Handover Email">Resend Email</button>
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" mat-raised-button color="primary" (click)="forceSearch()" i18n="@@actions.refresh"
        id="actions.refresh">Refresh</button>
    </div>
  </mat-card-content>
</mat-card>
